import React from 'react';
import './App.scss';

import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import Header from './sections/HeaderSection/HeaderSection';
import Home from './pages/Home';
import Poligrafia from './pages/Poligrafia';
import Studio from './pages/Studio';
import Realizacje from './pages/Realizacje';
import FAQ from './pages/FAQ';
import FooterSection from './sections/FooterSection/FooterSection';
import RealizacjeProdukt from './pages/RealizacjeProdukt';
import Arkusz from './pages/Arkusz';
import Rolka from './pages/Rolka';

import ScrollToTop from './ScrollTop';

function App() {

  // const isPreprod = document.location.href.includes("printlabel.pl");
  const baseName = '/';

  return (
    <React.Fragment>
      <Router basename={baseName}>
      <ScrollToTop />
        <Header />
        <Switch>
          <Route exact path="/arkusz">
            <Arkusz />
          </Route>
          <Route exact path="/rolka">
            <Rolka />
          </Route>
          <Route path="/poligrafia">
            <Poligrafia/>
          </Route>
          <Route path="/studio">
            <Studio/>
          </Route>
          <Route exact path="/realizacje/:id">
            <RealizacjeProdukt />
          </Route>
          <Route path="/realizacje">
            <Realizacje/>
          </Route>
          <Route path="/faq">
            <FAQ/>
          </Route>
          <Route exact path="/">
            <Home />
          </Route>
        </Switch>
        <FooterSection />
      </Router>
    </React.Fragment>
  );
}

export default App;
